<template>
  <div class="LoadingFlatIndeterminate">
    <div class="progress-bar-value"/>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="postcss">
.LoadingFlatIndeterminate {
  @apply h-4 bg-bg-inactive w-full overflow-hidden;
}

.progress-bar-value {
  @apply w-full h-full bg-bg-brandStrong;
  animation: indeterminateAnimation 1s infinite linear;
  transform-origin: 0% 50%;
}

@keyframes indeterminateAnimation {
  0% {
    transform:  translateX(0) scaleX(0);
  }
  40% {
    transform:  translateX(0) scaleX(0.4);
  }
  100% {
    transform:  translateX(100%) scaleX(0.5);
  }
}

</style>
